import { useUserStore } from "@/stores/useUserStore";
import { CountriesItemProps, MenuItemProps } from "../Utils/constants";
import { useEffect, useState } from "react";
import Image from "next/image";
import { useAddressStore } from "@/stores/useAddressStore";
import axios from "axios";
import { getNewToken } from "@/lib/Definitions";
import Cookies from "js-cookie";
import AlertDialog from "../Utils/AlertDialog";


const Address = (props: MenuItemProps) => {
  const viewport = Cookies.get('viewport');
  const { userInfo, getUser, updateUser } = useUserStore();
  const { updateAddress, getAddress } = useAddressStore();
  const [userData, setUserData] = useState(getUser());
  const [addressData, setAddressData] = useState(getAddress());
  const [firstName, setFirstName] = useState(addressData.first_name);
  const [lastName, setLastName] = useState(addressData.last_name);
  const [email, setEmail] = useState(addressData.email);
  const [country, setCountry] = useState(addressData.country);
  const [countryValue, setCountryValue] = useState(addressData.country_value);
  const [state, setState] = useState(addressData.state);
  const [postalCode, setPostalCode] = useState(addressData.zip_code);
  const [city, setCity] = useState(addressData.city);
  const [address, setAddress] = useState(addressData.street);
  const [countryCode, setCountryCode] = useState(addressData.country_code);
  const [phone, setPhone] = useState(addressData.mobile);
  const [addressId, setAddressId] = useState(addressData.id);
  const [countries, setCountries] = useState<Array<CountriesItemProps>>([]);
  const [stateList, setStateList] = useState<Array<string> | null>(null);
  const [init, setInit] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [open, setOpen] = useState(false);

  const update_address = async () => {
    const email_expression: RegExp = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

    if (lastName.length === 0 && firstName.length === 0) {
      setMessage("Please fill your name");
    } else if (email.length === 0) {
      setMessage("Please fill your email");
    } else if (!email_expression.test(email)) {
      setMessage("Please fill correct email format");
    } else if (country.length === 0) {
      setMessage("Please select your country");
    } else if (address.length === 0) {
      setMessage("Please fill your address");
    } else if (phone.length === 0) {
      setMessage("Please fill your phone number");
    } else if (postalCode.length === 0) {
      setMessage("Please fill your postal code");
    } else {
      setIsLoading(true);

      const data = {
        name: lastName + " " + firstName,
        mobile: countryCode + phone,
        country: country,
        state: state,
        city: city,
        street: address,
        zip_code: postalCode,
        email: email
      };

      if (addressId === 0 || addressId === undefined) {
        const address_data = {
          first_name: firstName,
          last_name: lastName,
          country_code: countryCode,
          mobile: phone,
          country: country,
          country_value: countryValue,
          state: state,
          city: city,
          street: address,
          zip_code: postalCode,
          email: email,
          id: undefined
        };

        updateAddress(address_data);
        setAddressData(address_data);

        try {
          const response = await axios.post(
            '/api/address',
            data,
            { headers: { Authorization: 'Bearer ' + userData.token } }
          );

          if (response.data.status === "ok") {
            setAddressId(response.data.data.id);
            address_data.id = response.data.data.id;
            updateAddress(address_data);
          }
        } catch (error: any) {
          if (error.response.data.error === "Invalid credentials") {
            const response: any = await getNewToken(userData.token, userData.refresh_token, userData.uuid);

            if (response !== "") {
              userData.token = response.token;
              userData.refresh_token = response.refresh_token;
              updateUser(userData);
              update_address();
            }
          }
        }
      } else {
        const address_data = {
          first_name: firstName,
          last_name: lastName,
          country_code: countryCode,
          mobile: phone,
          country: country,
          country_value: countryValue,
          state: state,
          city: city,
          street: address,
          zip_code: postalCode,
          email: email,
          id: addressId
        };

        updateAddress(address_data);
        setAddressData(address_data);

        try {
          const response = await axios.put(
            '/api/address/' + addressId,
            data,
            { headers: { Authorization: 'Bearer ' + userData.token } }
          );
        } catch (error: any) {
          if (error.response.data.error === "Invalid credentials") {
            const response: any = await getNewToken(userData.token, userData.refresh_token, userData.uuid);

            if (response !== "") {
              userData.token = response.token;
              userData.refresh_token = response.refresh_token;
              updateUser(userData);
              update_address();
            }
          }
        }
      }
    }
  }

  useEffect(() => {
    if (message !== "") {
      setOpen(true);
    }
  }, [message]);

  useEffect(() => {
    if (!open) {
      setMessage("");
    }
  }, [open]);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await axios.get(
          '/api/countries',
          { headers: { Authorization: 'Bearer ' + userData.token } }
        )
  
        if (response.data.status === "ok") {
          setCountries(response.data.data)
        }
      } catch (error: any) {
        if (error.response.data.error === "Invalid credentials") {
          const response: any = await getNewToken(userData.token, userData.refresh_token, userData.uuid);
  
          if (response !== "") {
            userData.token = response.token;
            userData.refresh_token = response.refresh_token;
            updateUser(userData);
            fetchCountries();
          }
        }
      } finally {
        setIsLoading(false);
      }
    }

    if (init) {
      setIsLoading(true);
      fetchCountries();
      setInit(false);
    }
  }, [init, updateUser, userData])

  useEffect(() => {
    const selected_countries = countries.filter(cc => cc.country === country)

    if (selected_countries.length > 0) {
      const sc = selected_countries[0];

      setCountryValue(sc.value);
      setCountryCode(sc.code);

      if (sc.state === null || sc.state.length === 0) {
        setStateList(null);
      } else {
        setStateList(sc.state.split(','));
      }
    }
  }, [countries, country, setCountryCode, setCountryValue])

  useEffect(() => {
    setUserData(getUser());
  }, [userInfo, getUser])

  return (
    <div className="w-full font-dmsans">
      <div className="flex items-center space-x-4">
        <div>
          <Image
            src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icon/user-home-icon.png"}
            alt="Account Detail icon"
            width={20}
            height={20}
            quality={100}
            className="hidden md:block"
          />
          <Image
            src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icon/arrow-right.svg"}
            alt="left arrow icon"
            width={24}
            height={24}
            quality={100}
            className="rotate-180 md:hidden"
            onClick={() => props.setSelected("")}
          />
        </div>
        <p className="text-base text-[#2C3E2F] font-dmsans font-bold">Address</p>
      </div>
      <hr className="w-full my-6 h-[1px] bg-[#C6C6C6]" />
      <div className="flex items-center py-2">
        <Image
          src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icon/checkout/account.png"}
          alt="account icon"
          width={24}
          height={24}
          quality={100}
        />
        <div className="grid w-full grid-cols-2 ml-4 gap-x-2">
          <input
            type="text"
            value={firstName}
            className="h-9 p-2 text-sm text-[#2C3E2F] w-full border-b border-[#C6C6C6] border-solid bg-[#FCFCF8] focus:outline-none"
            placeholder="First name"
            onChange={event => setFirstName(event.target.value)}
          />
          <input
            type="text"
            value={lastName}
            className="h-9 p-2 text-sm text-[#2C3E2F] w-full border-b border-[#C6C6C6] border-solid bg-[#FCFCF8] focus:outline-none"
            placeholder="Last name"
            onChange={event => setLastName(event.target.value)}
          />
        </div>
      </div>
      <div className="flex py-2 mt-6 items-top">
        <div className="flex items-center h-9">
          <Image
            src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icon/checkout/address-mark.png"}
            alt="address mark icon"
            width={24}
            height={24}
            quality={100}
          />
        </div>
        <div className="grid w-full grid-cols-1 ml-4 md:grid-cols-3 gap-x-2 gap-y-6">
          <div className="relative order-1 select-container">
            <select
              name="country"
              value={country}
              className="h-9 pl-1 p-2 text-sm text-[#2C3E2F] w-full border-b border-[#C6C6C6] border-solid bg-[#FCFCF8]"
              onChange={event => setCountry(event.target.value)}
            >
              <option value="">Select Country</option>
              {countries.map((country, index) => (
                <option value={country.country} key={index}>{country.country}</option>
              ))}
            </select>
            <Image
              src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icon/dropdown.png"}
              alt="dropdown icon"
              width={24}
              height={24}
              quality={100}
              className="absolute right-0 -translate-y-1/2 pointer-events-none top-1/2"
            />
          </div>
          <div className="relative order-2 py-2 md:py-0 select-container">
            {stateList === null ? (
              <input
                type="text"
                value={state}
                className="h-9 p-2 text-sm text-[#2C3E2F] w-full border-b border-[#C6C6C6] border-solid bg-[#FCFCF8] focus:outline-none"
                placeholder="State (Optional)"
                onChange={event => setState(event.target.value)}
              />
            ) : (
              <>
                <select
                  name="state"
                  value={state}
                  className="h-9 pl-1 p-2 text-sm text-[#2C3E2F] w-full border-b border-[#C6C6C6] border-solid bg-[#FCFCF8]"
                  onChange={event => setState(event.target.value)}
                >
                  <option value="">Select State</option>
                  {stateList.map((state, index) => (
                    <option value={state} key={index}>{state}</option>
                  ))}
                </select>
                  <Image
                  src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icon/dropdown.png"}
                  alt="dropdown icon"
                  width={24}
                  height={24}
                  quality={100}
                  className="absolute right-0 -translate-y-1/2 pointer-events-none top-1/2"
                />
              </>
            )}
          </div>
          <div className="order-5 py-2 md:py-0 md:order-3">
              <input
                type="text"
                value={postalCode}
                className="h-9 p-2 text-sm text-[#2C3E2F] w-full border-b border-[#C6C6C6] border-solid bg-[#FCFCF8] focus:outline-none"
                placeholder="Postal code"
                onChange={event => setPostalCode(event.target.value)}
              />
          </div>
          <div className="order-3 py-2 md:col-span-3 md:order-4">
            <input
              type="text"
              value={city}
              className="h-9 p-2 text-sm text-[#2C3E2F] w-full border-b border-[#C6C6C6] border-solid bg-[#FCFCF8] focus:outline-none"
              placeholder="City / Town (Optional)"
              onChange={event => setCity(event.target.value)}
            />
          </div>
          <div className="order-4 py-2 md:col-span-3 md:order-5">
            <input
              type="text"
              value={address}
              className="h-9 p-2 text-sm text-[#2C3E2F] w-full border-b border-[#C6C6C6] border-solid bg-[#FCFCF8] focus:outline-none"
              placeholder="Address"
              onChange={event => setAddress(event.target.value)}
            />
          </div>
        </div>
      </div>
      <div className="flex items-center py-2 mt-6">
        <Image
          src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icon/checkout/phone.png"}
          alt="phone icon"
          width={24}
          height={24}
          quality={100}
        />
        <div className="grid w-full grid-cols-7 ml-4 gap-x-2">
          <input
            type="text"
            value={countryCode}
            className="h-9 p-2 text-sm text-[#2C3E2F] w-full border-b border-[#C6C6C6] border-solid bg-[#FCFCF8] col-span-2 focus:outline-none"
            placeholder={viewport === "desktop" ? "Country code" : "Code"}
            onChange={event => setCountryCode(event.target.value)}
          />
          <input
            type="text"
            value={phone}
            className="h-9 p-2 text-sm text-[#2C3E2F] w-full border-b border-[#C6C6C6] border-solid bg-[#FCFCF8] col-span-5 focus:outline-none"
            placeholder="Phone number"
            onChange={event => setPhone(event.target.value)}
          />
        </div>
      </div>
      <div className="w-full flex items-center justify-center mt-6">
        <button
          className="px-4 py-2 text-base text-white font-medium text-center bg-[#A6CAA6] w-full md:w-2/3 rounded-lg"
          onClick={update_address}
        >
          Save
        </button>
      </div>
      <AlertDialog message={message} open={open} setOpen={setOpen} />
    </div>
  )
}

export default Address;
